import { defineMessages } from '@/i18n';

export const backOfficeMessages = defineMessages({
  artworksTitle: 'platform.app.gallery.artworks.title',
  inventoryTitleBuyer: 'platform.app.gallery.artworks.titleBuyer',
  artworkCreateTitle: 'platform.app.gallery.artworkCreate.title',
  bulkUploadTitle: 'platform.app.gallery.bulkUpload.title',
  artworkDetailTitle: 'platform.app.gallery.artworkDetail.title',
  artworkEditTitle: 'platform.app.gallery.artworkEdit.title',
  buyerPurchaseRequestsTitle: 'platform.app.gallery.purchaseRequests.buyer.title',
  sellerPurchaseRequestsTitle: 'platform.app.gallery.purchaseRequests.seller.title',
  purchaseRequestDetailTitle: 'platform.app.purchaseRequest.purchaseRequestDetailTitle',
  description: 'platform.app.gallery.purchaseRequest.detail.description',
  billingAddress: 'platform.app.gallery.purchaseRequest.detail.billingAddress',
  shippingAddress: 'platform.app.gallery.purchaseRequest.detail.shippingAddress',
  artworkTitle: 'platform.app.gallery.purchaseRequest.detail.artworkTitle',
  artworkInitialPriceLabel: 'platform.app.gallery.purchaseRequest.detail.artworkInitialPriceLabel',
  collectorBioLabel: 'platform.app.gallery.purchaseRequest.detail.collectorBioLabel',
  collectorContactLabel: 'platform.app.gallery.purchaseRequest.detail.contact',
  submittedOn: 'platform.app.gallery.purchaseRequest.detail.submittedOn',
  // Id: 'platform.app.gallery.purchaseRequest.detail.Id',
  acceptButton: 'platform.app.gallery.purchaseRequest.detail.acceptButton',
  declineButton: 'platform.app.gallery.purchaseRequest.detail.declineButton',
  sendSalesAgreementButton: 'platform.app.gallery.purchaseRequest.detail.sendSalesAgreementButton',
  terminateButton: 'platform.app.gallery.purchaseRequest.detail.terminateButton',
  proposalSentMessage: 'platform.app.gallery.purchaseRequest.detail.proposalSentMessage',
  // AcceptedModalTitle: 'platform.app.gallery.purchaseRequest.detail.AcceptedModal.title',
  terminatePurchaseRequestModalTitle: 'platform.app.gallery.purchaseRequest.detail.terminatePurchaseRequestModal.title',
  terminatePurchaseRequestModalDescription:
    'platform.app.gallery.purchaseRequest.detail.terminatePurchaseRequestModal.description',
  terminatePurchaseRequestModalErrorDescription:
    'platform.app.gallery.purchaseRequest.detail.terminatePurchaseRequestModal.errorDescription',
  terminatePurchaseRequestModalTerminateBtn:
    'platform.app.gallery.purchaseRequest.detail.terminatePurchaseRequestModal.terminateBtn',
  terminatePurchaseRequestModalCancelBtn:
    'platform.app.gallery.purchaseRequest.detail.terminatePurchaseRequestModal.cancelBtn',
  declinePurchaseRequestTitle: 'platform.app.gallery.purchaseRequest.detail.declinePurchaseRequest.title',
  declinePurchaseRequestDescription: 'platform.app.gallery.purchaseRequest.detail.declinePurchaseRequest.description',
  declinePurchaseRequestReasonLabel: 'platform.app.gallery.purchaseRequest.detail.declinePurchaseRequest.reasonLabel',
  declinePurchaseRequestDeclineBtn: 'platform.app.gallery.purchaseRequest.detail.declinePurchaseRequest.declineBtn',
  declinePurchaseRequestCancelBtn: 'platform.app.gallery.purchaseRequest.detail.declinePurchaseRequest.cancelBtn',
  updatedPurchaseRequestsNotificationTitle: 'platform.app.gallery.notifications.updatedPurchaseRequests.title',
  updatedPurchaseRequestsNotificationDescription:
    'platform.app.gallery.notifications.updatedPurchaseRequests.description',
  updatedPurchaseRequestsNotificationPrimaryAction:
    'platform.app.gallery.notifications.updatedPurchaseRequests.primaryAction',
  updatedPurchaseRequestsNotificationSecondaryAction:
    'platform.app.gallery.notifications.updatedPurchaseRequests.secondaryAction',
  dismiss: 'platform.app.gallery.paymentStatusBanner.dismiss',
  completeOnboarding: 'platform.app.gallery.paymentStatusBanner.completeOnboarding',
  paymentProfileVerified: 'platform.app.gallery.paymentStatusBanner.paymentProfileVerified',
  paymentProfileNotVerified: 'platform.app.gallery.paymentStatusBanner.paymentProfileNotVerified',
  paymentProfileVerifiedDescription: 'platform.app.gallery.paymentStatusBanner.paymentProfileVerifiedDescription',
  paymentProfileNotVerifiedDescription: 'platform.app.gallery.paymentStatusBanner.paymentProfileNotVerifiedDescription',
  buyerTitle: 'platform.app.gallery.purchaseRequest.detail.buyer.title',
  proposalTitle: 'platform.app.gallery.purchaseRequest.detail.proposal.title',
  success: 'platform.app.gallery.notifications.success',
  artworkPublished: 'platform.app.gallery.notifications.artworkPublished',
  artworkUnpublished: 'platform.app.gallery.notifications.artworkUnpublished',
  artworkDeleted: 'platform.app.gallery.notifications.artworkDeleted',
  documentDeleted: 'platform.app.gallery.notifications.documentDeleted',
  documentEdited: 'platform.app.gallery.notifications.documentUpdated',

  // dialogs
  leaveDialogTitle: 'platform.app.dialog.exitPage.title',
  leaveDialogMessage: 'platform.app.dialog.exitPage.message',
});

export { salesAgreementMessages } from './sales-agreement/salesAgreement.messages';
